import { B, INDUSTRY_BENCHMARKS } from "../data/pillars";

export default function BenchmarkBanner({ vertical, avgScore }) {
  if (!vertical || !INDUSTRY_BENCHMARKS[vertical]) return null;
  const bench = INDUSTRY_BENCHMARKS[vertical];
  const diff  = avgScore - bench;
  const ahead = diff > 0;
  const color = ahead ? B.green : diff > -0.5 ? B.yellow : B.red;

  return (
    <div style={{ background: color + "12", border: `1px solid ${color}40`, borderRadius: 12, padding: "18px 22px", marginBottom: 20 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ fontSize: 28 }}>📊</div>
          <div>
            <div style={{ fontSize: 11, color, fontWeight: 800, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Industry Benchmark</div>
            <div style={{ color: B.white, fontSize: 15, fontWeight: 700 }}>
              Companies your size in <span style={{ color: B.accent }}>{vertical}</span> average OML <span style={{ color: B.accent }}>{bench.toFixed(1)}</span>
              {" — "}you're at <span style={{ color }}>{avgScore.toFixed(1)}</span>
            </div>
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 22, fontWeight: 900, color }}>{ahead ? "+" : ""}{diff.toFixed(1)}</div>
          <div style={{ fontSize: 11, color: B.subText, fontWeight: 600 }}>{ahead ? "above average" : "below average"}</div>
        </div>
      </div>
      {!ahead && (
        <div style={{ marginTop: 12, fontSize: 13, color: B.lightGray, lineHeight: 1.6 }}>
          📌 Closing this gap to industry average represents a meaningful reduction in risk exposure and positions {vertical.toLowerCase()} organizations for compliance readiness and competitive parity.
        </div>
      )}
    </div>
  );
}